import React from "react";

const Icon = ({ name, size = 20, sw = 2, c = "currentColor" }) => {
  const p = {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: c,
    strokeWidth: sw,
    strokeLinecap: "round",
    strokeLinejoin: "round",
  };
  switch (name) {
    case "send":
      return (
        <svg {...p}>
          <path d="m4 12 16-8-6 18-3-8-7-2Z" />
        </svg>
      );
    case "search":
      return (
        <svg {...p}>
          <circle cx="11" cy="11" r="6.5" />
          <path d="m20 20-3.5-3.5" />
        </svg>
      );
    case "message":
      return (
        <svg {...p}>
          <path d="M21 12a8 8 0 0 1-11.6 7.1L4 20l1-4.4A8 8 0 1 1 21 12Z" />
        </svg>
      );
    case "contacts":
      return (
        <svg {...p}>
          <circle cx="12" cy="9" r="3.5" />
          <path d="M5 20c0-3 3-5 7-5s7 2 7 5" />
        </svg>
      );
    case "settings":
      return (
        <svg {...p}>
          <circle cx="12" cy="12" r="3" />
          <path d="M12 3v2M12 19v2M5.6 5.6l1.4 1.4M17 17l1.4 1.4M3 12h2M19 12h2M5.6 18.4 7 17M17 7l1.4-1.4" />
        </svg>
      );
    case "back":
      return (
        <svg {...p}>
          <path d="m15 6-6 6 6 6" />
        </svg>
      );
    case "close":
      return (
        <svg {...p}>
          <path d="M6 6l12 12M18 6 6 18" />
        </svg>
      );
    case "more":
      return (
        <svg {...p}>
          <circle cx="12" cy="12" r="1.4" fill={c} />
          <circle cx="6" cy="12" r="1.4" fill={c} />
          <circle cx="18" cy="12" r="1.4" fill={c} />
        </svg>
      );
    case "flame":
      return (
        <svg {...p}>
          <path d="M12 3s4 4 4 9a4 4 0 0 1-8 0c0-2 1-3 1-3s2 5 4 4-1-6-1-10Z" />
        </svg>
      );
    case "heart":
      return (
        <svg {...p}>
          <path d="M12 20s-7-4.5-7-10a4 4 0 0 1 7-2.7A4 4 0 0 1 19 10c0 5.5-7 10-7 10Z" />
        </svg>
      );
    case "heartFill":
      return (
        <svg {...p} fill={c} stroke="none">
          <path d="M12 20s-7-4.5-7-10a4 4 0 0 1 7-2.7A4 4 0 0 1 19 10c0 5.5-7 10-7 10Z" />
        </svg>
      );
    case "spark":
      return (
        <svg {...p}>
          <path d="M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8L12 3Z" />
        </svg>
      );
    case "crown":
      return (
        <svg {...p}>
          <path d="M3 8l4 3 5-6 5 6 4-3-2 11H5L3 8Z" />
        </svg>
      );
    case "globe":
      return (
        <svg {...p}>
          <circle cx="12" cy="12" r="9" />
          <path d="M3 12h18M12 3a14 14 0 0 1 0 18M12 3a14 14 0 0 0 0 18" />
        </svg>
      );
    case "shuffle":
      return (
        <svg {...p}>
          <path d="M16 4h5v5" />
          <path d="M4 20 21 4" />
          <path d="M21 16v5h-5" />
          <path d="m15 15 6 6" />
          <path d="M4 4l5 5" />
        </svg>
      );
    case "plus":
      return (
        <svg {...p}>
          <path d="M12 5v14M5 12h14" />
        </svg>
      );
    case "trash":
      return (
        <svg {...p}>
          <path d="M3 6h18M8 6V4h8v2M6 6l1 14h10l1-14M10 11v6M14 11v6" />
        </svg>
      );
    case "user":
      return (
        <svg {...p}>
          <circle cx="12" cy="8" r="4" />
          <path d="M4 21c0-4.4 3.6-8 8-8s8 3.6 8 8" />
        </svg>
      );
    case "camera":
      return (
        <svg {...p}>
          <path d="M4 8h3l1.5-2h7L17 8h3v11H4z" />
          <circle cx="12" cy="13" r="3" />
        </svg>
      );
    case "shield":
      return (
        <svg {...p}>
          <path d="M12 3 4 6v6c0 5 3.5 8 8 9 4.5-1 8-4 8-9V6l-8-3Z" />
        </svg>
      );
    case "bell":
      return (
        <svg {...p}>
          <path d="M6 8a6 6 0 0 1 12 0c0 7 3 7 3 9H3c0-2 3-2 3-9Z" />
          <path d="M10 21a2 2 0 0 0 4 0" />
        </svg>
      );
    case "lock":
      return (
        <svg {...p}>
          <rect x="5" y="11" width="14" height="9" rx="2" />
          <path d="M8 11V8a4 4 0 0 1 8 0v3" />
        </svg>
      );
    case "logout":
      return (
        <svg {...p}>
          <path d="M9 4H5v16h4M16 17l5-5-5-5M21 12H10" />
        </svg>
      );
    case "save":
      return (
        <svg {...p}>
          <path d="M5 4h12l3 3v13H5z" />
          <path d="M8 4v5h8V4" />
        </svg>
      );
    case "chevron":
      return (
        <svg {...p}>
          <path d="m9 6 6 6-6 6" />
        </svg>
      );
    case "chevDown":
      return (
        <svg {...p}>
          <path d="m6 9 6 6 6-6" />
        </svg>
      );
    case "checkCircle":
      return (
        <svg {...p}>
          <circle cx="12" cy="12" r="9" />
          <path d="m8 12 3 3 5-6" />
        </svg>
      );
    case "x":
      return (
        <svg {...p}>
          <path d="M6 6l12 12M18 6 6 18" />
        </svg>
      );
    case "star":
      return (
        <svg {...p}>
          <path d="M12 3l2.5 6 6.5.5-5 4.5L17.5 21 12 17l-5.5 4 1.5-7L3 9.5 9.5 9 12 3Z" />
        </svg>
      );
    case "sliders":
      return (
        <svg {...p}>
          <path d="M4 6h13M4 12h7M4 18h11" />
          <circle cx="19" cy="6" r="2" />
          <circle cx="14" cy="12" r="2" />
          <circle cx="17" cy="18" r="2" />
        </svg>
      );
    case "verified":
      return (
        <svg {...p}>
          <path d="m3 12 2-3-1-3 3-1 2-3 3 2 3-2 2 3 3 1-1 3 2 3-2 3 1 3-3 1-2 3-3-2-3 2-2-3-3-1 1-3-2-3Z" />
          <path d="m9 12 2 2 4-4" />
        </svg>
      );
    case "image":
      return (
        <svg {...p}>
          <rect x="3" y="4" width="18" height="16" rx="2" />
          <circle cx="9" cy="10" r="2" />
          <path d="m21 16-5-5-9 9" />
        </svg>
      );
    default:
      return null;
  }
};

export default Icon;
